import React, { useEffect, useState, useRef } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function PaymentResult({ ok }) {
  const [sp] = useSearchParams();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [status, setStatus] = useState(ok ? "checking" : "cancel");
  const tries = useRef(0);

  useEffect(() => {
    if (!ok) return;
    const sid = sp.get("session_id");
    if (!sid) { setStatus("error"); return; }
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { setStatus("paid"); await refresh(); return; }
        if (data.status === "expired" || tries.current > 15) { setStatus("error"); return; }
      } catch { if (tries.current > 15) { setStatus("error"); return; } }
      tries.current += 1;
      setTimeout(poll, 2000);
    };
    poll();
  }, [ok, sp, refresh]);

  return (
    <div className="min-h-screen grid place-items-center bg-[#09090b] px-6">
      <div className="jx-card rounded-3xl p-10 text-center max-w-md">
        {status === "checking" && <><Loader2 className="animate-spin text-purple-400 mx-auto mb-4" size={40} /><p className="font-semibold">Confirming your payment…</p><p className="text-sm text-slate-400 mt-1">Please wait, we're verifying with Stripe.</p></>}
        {status === "paid" && <><CheckCircle2 className="text-green-400 mx-auto mb-4" size={48} /><h1 className="text-2xl font-bold font-display">Subscription active!</h1><p className="text-slate-400 mt-2">Your AI Music Studio is unlocked. Let's make something.</p><button onClick={() => navigate("/studio")} className="jx-cta text-white font-semibold px-6 py-3 rounded-xl mt-5">Open Studio</button></>}
        {(status === "cancel" || status === "error") && <><XCircle className="text-rose-400 mx-auto mb-4" size={48} /><h1 className="text-2xl font-bold font-display">{status === "cancel" ? "Checkout canceled" : "Couldn't confirm payment"}</h1><p className="text-slate-400 mt-2">No charge was completed. You can try again anytime.</p><Link to="/plans" className="inline-block jx-cta text-white font-semibold px-6 py-3 rounded-xl mt-5">Back to Plans</Link></>}
      </div>
    </div>
  );
}
